<template>
  <validation-observer ref="refFormObserver">
    <b-row class="mx-0">
      <b-col cols="6">
        <validation-provider
          #default="validationContext"
          :name="$tc('centers.title', 1)"
          rules="required"
        >
          <b-form-group
            :label="$tc('centers.title', 1)"
            label-for="id_center"
            :state="getValidationState(validationContext)"
          >
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="centerOptions"
              class="w-100"
              :reduce="(val) => val.value"
              v-model="itemDataExtra.id_center"
              append-to-body
              :calculate-position="withPopper"
            />
            <b-form-invalid-feedback :state="getValidationState(validationContext)">
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col cols="6">
        <validation-provider
          #default="validationContext"
          :name="$tc('sectors.title', 1)"
          rules="required"
        >
          <b-form-group
            :label="$tc('sectors.title', 1)"
            label-for="id_sector"
            :state="getValidationState(validationContext)"
          >
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="sectorOptions"
              class="w-100"
              :reduce="(val) => val.value"
              v-model="itemDataExtra.id_sector"
              append-to-body
              :calculate-position="withPopper"
            />
            <b-form-invalid-feedback :state="getValidationState(validationContext)">
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col cols="6">
        <validation-provider
          #default="validationContext"
          :name="$t('camera.previous_time_of_prealarma')"
          rules="required"
        >
          <b-form-group
            class="text-capitalize"
            :label="$t('camera.previous_time_of_prealarma')"
            label-for="delayed_record_minutes"
            :state="getValidationState(validationContext)"
          >
            <flat-pickr
              id="delayed_record_minutes"
              class="form-control"
              :config="{
                enableTime: true,
                dateFormat: 'H:i:S',
                time_24hr: true,
                noCalendar: true,
                enableSeconds: true,
                minuteIncrement: 1,
              }"
              v-model="itemDataExtra.delayed_record_minutes"
            />
            <b-form-invalid-feedback :state="getValidationState(validationContext)">
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col cols="6">
        <validation-provider
          #default="validationContext"
          :name="$t('camera.later_time_of_prealarma')"
          rules="required"
        >
          <b-form-group
            class="text-capitalize"
            :label="$t('camera.later_time_of_prealarma')"
            label-for="forward_record_minutes"
            :state="getValidationState(validationContext)"
          >
            <flat-pickr
              id="forward_record_minutes"
              class="form-control"
              :config="{
                enableTime: true,
                dateFormat: 'H:i:S',
                time_24hr: true,
                noCalendar: true,
                enableSeconds: true,
                minuteIncrement: 1,
              }"
              v-model="itemDataExtra.forward_record_minutes"
            />
            <b-form-invalid-feedback :state="getValidationState(validationContext)">
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col cols="6">
        <validation-provider
          #default="validationContext"
          name="Reseller"
          rules="required"
        >
          <b-form-group
            class="text-capitalize"
            label="Reseller"
            label-for="id_reseller"
            :state="getValidationState(validationContext)"
          >
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="resellerOptions"
              class="w-100"
              :reduce="(val) => val.value"
              v-model="itemDataExtra.id_reseller"
              append-to-body
              :calculate-position="withPopper"
            />
            <b-form-invalid-feedback :state="getValidationState(validationContext)">
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col cols="6">
        <validation-provider
          #default="validationContext"
          :name="$tc('unit.title', 1)"
          rules="required"
        >
          <b-form-group
            class="text-capitalize"
            :label="$tc('unit.title', 1)"
            label-for="id_unit"
            :state="getValidationState(validationContext)"
          >
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="unitOptions"
              class="w-100"
              :reduce="(val) => val.value"
              v-model="itemDataExtra.id_unit"
              append-to-body
              :calculate-position="withPopper"
            />
            <b-form-invalid-feedback :state="getValidationState(validationContext)">
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col cols="6">
        <b-form-checkbox
          v-model="itemDataExtra.is_fisheye"
          :value="true"
          :unchecked-value="false"
          class="my-1 text-capitalize"
          switch
        >
          Fisheye
        </b-form-checkbox>
      </b-col>
      <b-col cols="6">
        <b-form-checkbox
          v-model="itemDataExtra.send_to_seproban"
          :value="true"
          :unchecked-value="false"
          class="my-1 text-capitalize"
          switch
        >
          {{ $t('hanwha_camera.send_to_seproban') }}
        </b-form-checkbox>
      </b-col>
    </b-row>
  </validation-observer>
</template>

<script>
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";
import flatPickr from "vue-flatpickr-component";
import formValidation from "@core/comp-functions/forms/form-validation";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  components: {
    flatPickr,
    ValidationObserver,
    ValidationProvider,
    vSelect
  },
  props: {
    centerOptions: {
      type: Array,
      default: []
    },
    itemDataExtra: {
      type: Object
    },
    resellerOptions: {
      type: Array,
      default: []
    },
    unitOptions: {
      type: Array,
      default: []
    },
    sectorOptions: {
      type: Array,
      default: []
    }
  },
  setup () {
    //COMPOSABLES
    const { refFormObserver, getValidationState } = formValidation();

    //METHODS
    const validateStep = async () => {
      if (!refFormObserver.value) {
        console.warn("Validation observer is not initialized");
        return false;
      }
      const validation = await refFormObserver.value.validate();
      return validation;
    }

    return {
      getValidationState,
      refFormObserver,

      withPopper: popperHelper.withPopper,

      validateStep
    }
  }
}
</script>
